// src/components/Footer.js
import React from 'react';
import { FaFacebookF, FaInstagram } from 'react-icons/fa';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { scroller } from 'react-scroll';
import '../styles/Footer.css';

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Handle scroll navigation from other pages
  const handleScrollLink = (sectionId) => (e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      // If not on home page, navigate home first
      navigate('/', { state: { scrollToSection: sectionId } });
    } else {
      // If already on home page, just scroll
      scroller.scrollTo(sectionId, {
        duration: 500,
        smooth: true,
        offset: -80,
      });
    }
  };

  // Navigation items grouped by section
  const footerLinks = {
    services: [
      { to: '/services/tree-pruning', label: 'Tree Pruning', type: 'page' },
      { to: '/services/tree-removal', label: 'Tree Removal', type: 'page' },
      { to: '/services/stump-grinding', label: 'Stump Grinding', type: 'page' },
      { to: '/services/emergency-services', label: 'Emergency Services', type: 'page' },
      { to: '/services/tree-health', label: 'Tree Health', type: 'page' },
      { to: '/services/land-clearing', label: 'Land Clearing', type: 'page' },
    ],
    company: [
      { to: '/about-us', label: 'About Us', type: 'page' },
      { to: '/crew', label: 'Crew', type: 'page' },
      { to: '/gallery', label: 'Gallery', type: 'page' },
      { to: '/contact', label: 'Contact', type: 'page' },
    ],
  };

  // Render link based on type
  const renderFooterLink = (item) => {
    if (item.type === 'scroll') {
      return (
        <button
          className="FooterLink"
          onClick={handleScrollLink(item.to)}
          key={item.to}
        >
          {item.label}
        </button>
      );
    } else {
      return (
        <Link className="FooterLink" to={item.to} key={item.to}>
          {item.label}
        </Link>
      );
    }
  };

  return (
    <footer className="FooterSection">
      <div className="FooterContainer">
        <div className="FooterColumn">
          <h4 className="FooterTitle">Grizzly Tree Company</h4>
          <p className="FooterInfo">
            Founded by Nick Pedroza in Northern Nevada, we're a team of experienced 
            arborists and former wildland firefighters serving Reno, Gardnerville, 
            and the Tahoe region. Our unique blend of expertise ensures your trees 
            receive expert care, backed by our commitment to excellence and deep 
            understanding of local species.
          </p>
          <div className="SocialIcons">
            <a
              href="https://facebook.com"
              aria-label="Facebook"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaFacebookF />
            </a>
            <a
              href="https://instagram.com/grizzlytree.co"
              aria-label="Instagram"
              target="_blank"
              rel="noopener noreferrer"
            >
              <FaInstagram />
            </a>
          </div>
        </div>

        <div className="FooterColumn">
          <h4 className="FooterTitle">Services</h4>
          {footerLinks.services.map((link) => renderFooterLink(link))}
        </div>

        <div className="FooterColumn">
          <h4 className="FooterTitle">Company</h4>
          {footerLinks.company.map((link) => renderFooterLink(link))}
        </div>

        <div className="FooterColumn">
          <h4 className="FooterTitle">Contact</h4>
          <p className="FooterInfo">
            1640 Lantana Dr.<br />
            Minden, NV 89423<br />
            <a href="tel:+17753095630">(775) 309-5630</a><br />
            <a href="mailto:grizzlytreeco.99@gmail.com">grizzlytreeco.99@gmail.com</a>
          </p>
        </div>
      </div>
      <hr className="Divider" />
      <p className="Copyright">
        &copy; {new Date().getFullYear()} Grizzly Tree Company. All rights
        reserved.
      </p>
    </footer>
  );
};

export default Footer;